export default {
  methods: {
    withCMSBase(path) {
      return `https://cms.cloudify.biz${path}`
    },
  },
}
